<template>
  <div style="padding:100px 8%;">
    <div class="tab-pane pt-3 active show" v-if="ready">
      <div class="insurance-editor">
        <div class="row">
          <div class="col-12">
            <h4>報表註解設定</h4>
            <form class="form panel panel-form bg-white">
              <!-- 報表名稱 -->
              <div class="form-group row">
                <label class="col-2 text-right"><span class="text-red">＊</span>報表名稱</label>
                <div class="col-9">
                  <select
                    class="form-control form-control-inline form-xLarge"
                    v-model="formData.reportType"
                    @change="getReportNoteRecord"
                    >
                    <option
                      v-for="(item, index) in options.reports"
                      :key="index"
                      :value="item.type"
                      v-html="item.name"
                      >
                    </option>
                  </select>
                </div>
              </div>
              <!-- 備註內容 -->
              <div class="form-group row">
                <label class="col-2 text-right"><span class="text-red">＊</span>備註內容</label>
                <div class="col-9">
                  <textarea
                    v-model="formData.message"
                    class="form-control modal-footer"
                    :class="{'is-invalid': isMessageEmpty}"
                    rows="5"
                    maxlength="1500"
                    ></textarea>
                </div>
              </div>
              <!-- 是否套用所有商品 -->
              <div class="form-group row">
                <label class="col-2 text-right"></label>
                <div class="checkbox radio-inline col-9 ml-10">
                  <input type="checkbox" id="applyAll-checkbox" v-model="applyAll" :disabled="formData.reportType == '1'||formData.reportType == '22'">
                  <label for="applyAll-checkbox">是否套用所有商品  (若選擇套用所有商品，即為共同備註)</label>
                </div>
              </div>
              <!-- 公司別 -->
              <div class="flexbox-wrapper" :style="{height: flexBoxHeight+'px'}">
                <div class="flexbox-body" ref="flexboxBody">
                  <div class="form-group row" v-if="!applyAll">
                    <label class="col-2 text-right"><span class="text-red">＊</span>公司別</label>
                    <div class="col-9">
                      <select
                        class="form-control form-control-inline form-wide"
                        v-model="formData.companyId"
                        @change="doSearch"
                        >
                        <option
                          v-for="(item, index) in options.companies"
                          :key="index"
                          :value="item.COMPANYID"
                          >
                          {{ item.COMPSNM }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <!-- 商品種類 -->
                  <div class="form-group row" v-if="!applyAll">
                    <label class="col-2 text-right"><span class="text-red">＊</span>商品種類</label>
                    <div class="col-9">
                      <select
                        class="form-control form-control-inline form-wide"
                        v-model="formData.productType"
                        @change="doSearch"
                        >
                        <option
                          v-for="(item, index) in options.productType"
                          :key="index"
                          :value="item.value"
                          >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <!-- 險種種類 -->
                  <div class="form-group row" v-if="!applyAll">
                    <label class="col-2 text-right"><span class="text-red">＊</span>險種種類</label>
                    <div class="col-9">
                      <select
                        class="form-control form-control-inline form-wide"
                        v-model="formData.contractType"
                        @change="doSearch"
                        >
                        <option
                          v-for="(item, index) in options.contractType"
                          :key="index"
                          :value="item.value"
                          >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <!-- 關鍵字 -->
                  <div class="form-group row" v-if="!applyAll">
                    <label class="col-2 text-right">關鍵字</label>
                    <div class="col-9">
                      <input
                        type="text"
                        maxlength="100"
                        class="form-control form-control-inline"
                        v-model="formData.keyWord"
                        />
                    </div>
                  </div>
                  <div class="form-group row" v-if="!applyAll">
                    <label class="col-12 text-center">(若要以關鍵字搜尋商品，請務必於輸入完關鍵字後按下「GO」，就可以篩選出符合的險種；若<label class="text-red">不輸入</label>，會列出該公司所有險種供選擇)</label>
                  </div>
                  <div class="action mt-2 text-center" v-if="!applyAll">
                    <button
                      type="button"
                      class="btn btn-red"
                      @click="doSearch"
                      >
                    GO
                    </button>
                  </div>
                  <div class="form-group row" v-if="!applyAll"  :class="{'section-loading': isOptionLoading}">
                    <div class="col-5">
                      <select
                        multiple="multiple"
                        class="form-control form-control-inline selectBox"
                        v-model="formData.productAddList"
                        >
                        <option
                          v-for="(item, index) in options.productOption"
                          :key="index"
                          :value="item"
                          >
                          {{ item.name + item.plan_code }}
                        </option>
                      </select>
                    </div>
                    <div class="col-2 d-inline-grid">
                      <button
                        type="button"
                        class="btn btn-default delectBox-button"
                        @click="addProduct()"
                        >
                      加入&gt;&gt;
                      </button>
                      <button
                        type="button"
                        class="btn btn-default delectBox-button"
                        @click="removeProduct()"
                        >
                      &lt;&lt;移除
                      </button>
                    </div>
                    <div class="col-5">
                      <select
                        multiple="multiple"
                        class="form-control form-control-inline selectBox"
                        v-model="formData.productRemoveList"
                        :class="{'is-invalid': isProductEmpty}"
                        >
                        <option
                          v-for="(item, index) in options.productAddList"
                          :key="index"
                          :value="item"
                          >
                          {{ item.name + item.plan_code }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="action mt-2 text-center">
                <button
                  type="button"
                  class="btn btn-primary"
                  v-if="isEditMode"
                  @click="doUpdate()"
                  >
                更新
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  v-if="isEditMode"
                  @click="doDelete()"
                  >
                刪除
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  v-if="!isEditMode"
                  @click="doCreate()"
                  >
                新增
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  @click="doCancel()"
                  >
                取消
                </button>
              </div>
            </form>
          </div>
          <div class="col-12">
            <h4 class="text-green text-center">備註歷史紀錄清單</h4>
            <div class="form-group row">
              <div class="radio radio-inline ml-15">
                <input type="radio" id="showType-0" v-model="showType" value="0">
                <label for="showType-0">啟用清單</label>
              </div>
              <div class="radio radio-inline">
                <input type="radio" id="showType-1" v-model="showType" value="1">
                <label for="showType-1">歷史紀錄</label>
              </div>
            </div>
            <div class="modal-body" :class="{'section-loading': isTableLoading}">
              <table class="table datatable">
                <thead>
                  <tr>
                    <th style="width:45%" class="text-center">備註內容</th>
                    <th style="width:10%" class="text-center">姓名</th>
                    <th style="width:15%" class="text-center">時間</th>
                    <th style="width:5%" class="text-center">狀態</th>
                    <th style="width:10%" class="text-center">商品</th>
                    <th style="width:15%" class="text-center"></th>
                  </tr>
                </thead>
                <tbody v-if="reportNoteRecordList.length">
                  <tr v-for="(item, index) in reportNoteRecordList" :key="`noteRecord-${index}`">
                    <td>{{ item.message }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ dateFormat(item.createtime) }}</td>
                    <td class="text-center">{{ item.note_status == "0" ? "啟用" : "停用" }}</td>
                    <td v-if="item.productnum == '0'">共同備註</td>
                    <td v-else>
                      <a class="link text-underline" @click="openNoteAndProductListModal(item.state_id)">
                        {{ item.productnum }}
                      </a>
                    </td>
                    <td class="text-center">
                      <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        v-if="showType == '0'"
                        :disabled="isEditMode"
                        @click="doDisable(item.note_id)"
                        >
                      停用
                      </button>
                      <button
                        type="button"
                        class="btn btn-default btn-sm"
                        :disabled="isEditMode"
                        :id="`edit-note-button-${index}`"
                        @click="switchEditMode(item,index)"
                        >
                      修改
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="7">
                      <h4 class="mb-3">查無資料</h4>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <message
        class="mt-5 d-flex justify-content-center"
        loading
        message="資料讀取中，請稍候..."
        />
    </div>

    <Note-And-Product-List-Modal
      :open="noteAndProductListModalOpen"
      :inputList="noteAndProductListData"
      @close="panelClose('noteAndProductListModalOpen')"
    />
  </div>
</template>

<script>
import Message from "@/desktop/components/Message.vue";
import NoteAndProductListModal from "./components/NoteAndProductListModal";
import { commonMixin } from "@/mixins/common";
import {
  getCompanies,
  getAllReportType,
  getReportNoteRecord,
  queryProductByKeyWord,
  getReportNoteDetail,
  insertReportNoteDetail,
  queryProductListByStateId,
  disableReportNote,
  updateReportNoteDetail,
  deleteReportNote,
} from "@/service";
export default {
  name: "ReportNoteDetail",
  mixins: [commonMixin],
  components: {
    Message,
    NoteAndProductListModal,
  },
  data() {
    return {
      options: {
        companies: [],
        reports: [],
        productType: [
          {
            name: "傳統型",
            value: "1",
          },
          {
            name: "投資型",
            value: "2",
          },
          {
            name: "利率變動型",
            value: "3",
          },
          {
            name: "傳統型(取大)",
            value: "4",
          },
        ],
        contractType: [
          {
            name: "主約",
            value: "1",
          },
          {
            name: "附約",
            value: "2",
          },
        ],
        productOption: [],
        productAddList: [],
      },
      formData: {
        companyId: "",
        keyWord: "",
        insuranceCode: "",
        productType: "1",
        contractType: "1",
        reportType: "",
        message: "",
        productRemoveList: [],
        productAddList: [],
      },
      applyAll: false,
      showType: "0", //0:啟用 1:停用
      enableList: [], //啟用清單
      disableList: [], //歷史紀錄
      reportNoteRecordList: [],
      noteAndProductListData: [],
      editData: [], //編輯模式資料
      isMessageEmpty: false,
      isProductEmpty: false,
      isTableLoading: false,
      isOptionLoading: false,
      isEditMode: false, //切換編輯模式
      noteAndProductListModalOpen: false,
      flexBoxHeight: 0,
    };
  },
  watch: {
    showType() {
      this.switchTable();
    },
    applyAll(val) {
      if (val) {
        this.options.productAddList = [];
      }
      this.$nextTick(() => {
        this.flexBoxHeight = this.$refs.flexboxBody.getBoundingClientRect().height;
      });
    },
    "formData.reportType": function(val) {
      if (val == "1"||val == "22") {
        this.applyAll = true;
      } else {
        this.applyAll = false;
      }
    },
  },
  computed: {
    ready() {
      return (
        !window._.isEmpty(this.options.companies) &&
        !window._.isEmpty(this.options.reports)
      );
    },
  },
  methods: {
    async init() {
      await this.getCompaniesOption();
      await this.getReportOption();
      await this.getReportNoteRecord();
      await this.doSearch();
    },
    //取得公司別下拉清單
    async getCompaniesOption() {
      const res = await getCompanies(this.$store.state.userInfo.id);
      this.options.companies = res.body;
      this.formData.companyId = res.body[0].COMPANYID;
    },
    //查詢所有報表種類
    async getReportOption() {
      const res = await getAllReportType(this.$store.state.userInfo.id);
      this.options.reports = res.data;
      this.formData.reportType = res.data[0].type; //預設選擇第一個
    },
    //查詢備註歷史清單
    async getReportNoteRecord() {
      this.isTableLoading = true;
      await getReportNoteRecord(
        this.$store.state.userInfo.id,
        parseInt(this.formData.reportType)
      ).then((result) => {
        if (result.header && result.header.status == "200") {
          this.enableList = result.data.enablelist
            ? result.data.enablelist
            : [];
          this.disableList = result.data.disablelist
            ? result.data.disablelist
            : [];
          this.switchTable();
        } else {
          this.$toast.info({ title: result.header.message });
          this.enableList = [];
          this.disableList = [];
          this.reportNoteRecordList = [];
        }
        this.isTableLoading = false;
      });
    },
    switchTable() {
      if (this.showType == "0") {
        //啟用清單
        this.reportNoteRecordList = this.enableList;
      } else {
        //歷史紀錄
        this.reportNoteRecordList = this.disableList;
      }
    },
    dateFormat(val) {
      if (val) {
        let dataAry = val.split(" ")[0].split("-");
        return dataAry[0] + "年" + dataAry[1] + "月" + dataAry[2] + "日";
      }
      return "";
    },
    doSearch() {
      this.isOptionLoading = true;
      queryProductByKeyWord(this.$store.state.userInfo.id, this.formData).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.options.productOption = result.data;
          } else {
            this.options.productOption = [];
            this.$toast.info({ title: result.header.message });
          }
          this.isOptionLoading = false;
        }
      );
    },
    doDisable(data) {
      if (confirm("確認是否停用此備註！？")) {
        this.isTableLoading = true;
        disableReportNote(this.$store.state.userInfo.id, data).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "停用成功" });
              this.getReportNoteRecord();
            } else {
              this.$toast.info({ title: result.header.message });
            }
          }
        );
      }
    },
    doDelete() {
      if (confirm("確認是否刪除此備註！？")) {
        this.isTableLoading = true;
        deleteReportNote(
          this.$store.state.userInfo.id,
          this.editData.note_id
        ).then((result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "刪除成功" });
            this.isEditMode = false;
            this.initFormData();
            this.getReportNoteRecord();
          } else {
            this.$toast.info({ title: result.header.message });
          }
          this.isTableLoading = false;
        });
      }
    },
    doCancel() {
      this.isEditMode = false;
      this.initFormData();
    },
    doCreate() {
      if (this.validateForm()) {
        return;
      }

      let reqData = {
        userId: this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.name,
        message: this.formData.message,
        applyAll: this.applyAll,
        reportType: this.formData.reportType,
        productAddList: this.options.productAddList.map((x) => x.productid),
      };
      insertReportNoteDetail(this.$store.state.userInfo.id, reqData).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "新增成功" });
            this.initFormData();
            this.getReportNoteRecord();
          } else {
            this.$toast.info({ title: result.header.message });
          }
        }
      );
    },
    doUpdate() {
      if (this.validateForm()) {
        return;
      }

      let reqData = {
        userId: this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.name,
        message: this.formData.message,
        applyAll: this.applyAll,
        reportType: this.formData.reportType,
        stateId: this.editData.state_id,
        noteId: this.editData.note_id,
        productAddList: this.options.productAddList.map((x) => x.productid),
      };
      updateReportNoteDetail(this.$store.state.userInfo.id, reqData).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "更新成功" });
            this.isEditMode = false;
            this.initFormData();
            this.getReportNoteRecord();
          } else {
            this.$toast.info({ title: result.header.message });
          }
        }
      );
    },
    validateForm() {
      let isError = false;
      this.isMessageEmpty = false;
      this.isProductEmpty = false;
      if (!this.formData.message) {
        this.isMessageEmpty = true;
        isError = true;
        this.$toast.info({ title: "[備註內容]欄位不得為空" });
      }
      if (!this.applyAll && this.options.productAddList.length === 0) {
        this.isProductEmpty = true;
        isError = true;
        this.$toast.info({ title: "[商品清單]必須選擇一項以上商品" });
      }
      return isError;
    },
    addProduct() {
      this.formData.productAddList.forEach((item) => {
        if (
          !this.options.productAddList
            .map((x) => x.productid)
            .includes(item.productid)
        ) {
          this.options.productAddList = [item, ...this.options.productAddList];
        }
      });
      this.formData.productAddList = [];
    },
    removeProduct() {
      this.formData.productRemoveList.forEach((item) => {
        window._.remove(this.options.productAddList, {
          productid: item.productid,
        });
      });
      this.formData.productRemoveList = [];
    },
    openNoteAndProductListModal(data) {
      queryProductListByStateId(this.$store.state.userInfo.id, data).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.noteAndProductListData = result.data;
            this.panelOpen("noteAndProductListModalOpen");
          } else {
            this.$toast.info({ title: result.header.message });
          }
        }
      );
    },
    initFormData() {
      this.isMessageEmpty = false;
      this.isProductEmpty = false;
      this.formData.message = "";
      this.options.productAddList = [];
      if (this.formData.reportType != "1" && this.formData.reportType != "22") {
        this.applyAll = false;
      }
    },
    async switchEditMode(data, index) {
      this.isEditMode = true;
      this.initFormData();
      if (data.productnum != "0") {
        //非共同備註
        await getReportNoteDetail(
          this.$store.state.userInfo.id,
          data.state_id
        ).then((result) => {
          if (result.header && result.header.status == "200") {
            this.editData = result.data;
            this.options.productAddList = result.data.productlist;
          } else {
            this.$toast.info({ title: result.header.message });
          }
          $(`#edit-note-button-${index}`).attr("disabled", true);
        });
      } else {
        this.editData = data;
        this.applyAll = true;
      }
      this.formData.message = this.editData.message;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.mt-50 {
  margin-top: 50px;
}
.ml-15 {
  margin-left: 15px !important;
}
.ml-10 {
  margin-left: 10px !important;
}
.lh-50 {
  line-height: 50px;
}
.w-50 {
  width: 50px !important;
}
.w-150 {
  width: 150px !important;
}
.selectBox {
  width: 100% !important;
  height: 250px !important;
  background-image: none;
}
.d-inline-grid {
  display: inline-grid;
}
.delectBox-button {
  height: 50%;
}
.text-center {
  text-align: center;
}
.flexbox-wrapper {
  position: relative;
  overflow: hidden;
  transition: height 0.4s cubic-bezier(0.45, 0.05, 0.55, 0.95);
}
</style>
